
const Index = () => import('./Index')
const Show = () => import('./Show')
import Layout from '@/views/layouts/Layout'

export default [
    {
        path: '/applications',
        component: Layout,
        children: [
            { path: 'cpo-approving', component: Index, name: 'applications.cpo-approving' },
            { path: 'cpo-approving/:id', component: Show, name: 'applications.show' },
        ]
    },
];
